import {h, Fragment} from "preact"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"

import SelectedFilters from "./SelectedFilters"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import Products from "./Products"
import Pagination from "./Pagination"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"
import { useEffect } from "preact/hooks"

export function SerpBody({ loading, foundProducts }) {
    return (
        foundProducts ? (
            <>
                <Toolbar />
                <SelectedFilters />
                <div class="flex px-pagemargin">
                    <Sidebar />
                    <Products />
                </div>
                <Pagination />
            </>
        ) : loading ? (
            <Loader />
        ) : (
            <NoResults />
        )
    )
}

export function SerpBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <SelectedFilters />
            <Toolbar />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("search", SerpBodyInfiniteScroll)
export default wrapContent("search", SerpBody)
